/** Où la vidéo de démonstration est attendue (voir public/videos/README.md). */
export const VIDEO_DEMO = '/videos/assistant-demo.mp4';
export const AFFICHE_DEMO = '/videos/assistant-demo.jpg';

/**
 * Sans vidéo, la zone montre ce qu'on peut demander. Noms fictifs seulement :
 * cet écran est lu par tous les cabinets.
 */
export const EXEMPLES_SANS_VIDEO = [
  'Quels dossiers n’ont pas leur DSN d’août ?',
  'Lance les bulletins de Cabinet Exemple',
  'Change l’adresse d’un salarié d’Ateliers Voltaire',
];
